import React from "react";

const BS5_Utilities = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Utilities Component</h2>
      <p>This is the BS5_Utilities component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Utilities;
